import React, { useState } from 'react';
import PopupContainer from '../components/PopupContainer';
import { useNavigate } from 'react-router-dom';   // 🚀 ADD THIS
import { getSessionId, resetSessionId } from "../utils/sessionManager";

export default function ProfileSetup({ onFinish, profileData, onSelect }) {
  const [step, setStep] = useState(3);
  const navigate = useNavigate();
  const { persona } = getSessionId();
  if (!persona) {
  navigate("/");   // no persona → restart flow
}
  // --- Step Navigation ---
  const handleStartOver = () => {
   resetSessionId();
    navigate('/')
  };
  const handleNext = () => {
    if (step < 3) setStep(step + 1);
    else {
       navigate("/dashboard"); 
    }; // final callback
   
  };

  return (
    <PopupContainer>
      {/* Header */}
      <h1 className="setup-title">Accessibility Profile Setup</h1>
      <p className="setup-subtitle">
        Answer three quick questions to define your optimal experience.
      </p>

      {/* Progress Bar */}
      <div className="progress-row">
        <span className={`dot ${step >= 1 ? 'active' : ''}`}></span>
        <span className={`dot ${step >= 2 ? 'active' : ''}`}></span>
        <span className={`dot ${step >= 3 ? 'active' : ''}`}></span>
      </div>

      {/* Step Content */}
      <h2 className="middle-heading">{step === 3 ? 'Profile Defined!' : `Question ${step}`}</h2>

      <div className="input-box">
        <input
          type="text"
          placeholder={step === 3 ? profileData.persona?.final_persona : 'Enter your answer...'}
          disabled={true}
        />
      </div>

      {/* Buttons */}
      <div className="btn-row">
        <button className="btn start-btn" onClick={handleStartOver}>
          Start Over
        </button>
        <button className="btn next-btn" onClick={handleNext}>
          {step === 3 ? 'Finish' : 'Next'}
        </button>
      </div>
    </PopupContainer>
  );
}
